module.exports = __webpack_public_path__ + "img/mqttx-light.2440cb2c.png";